import styled from 'styled-components';

const CustomSwatchesContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

export default CustomSwatchesContainer;
